import { useRouteError } from "react-router";
import GlobalError from "@/components/layout/global-error";

export default function GlobalErrorBoundary() {
  const error = useRouteError();
  return <GlobalError error={error} />;
}
